import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Chapter } from "./shared";
import { IMG } from "../../lib/assets";

export const Showcase = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} id="screens" className="relative py-20 sm:py-28 lg:py-36 overflow-hidden" data-testid="showcase-section">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse 55% 45% at 50% 55%, rgba(255,77,10,0.06), transparent 70%)" }}
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <Chapter num="04" label="The instrument" />
        </Reveal>
        <Reveal>
          <h2 className="h-heavy text-[32px] sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl mb-10 sm:mb-14" data-testid="showcase-headline">
            Built for real decisions.
            <br />
            <span className="text-[#6E7178]">Not another mood tracker.</span>
          </h2>
        </Reveal>

        <Reveal>
          <motion.figure
            className="relative overflow-hidden hairline mx-auto max-w-5xl"
            data-testid="showcase-hero-image"
          >
            <motion.img
              style={{ y: imgY, scale: 1.16 }}
              src={IMG.showcasePhone}
              alt="A hand holding a phone showing a SOURCECODED side-by-side read: your day at 80, peak, against theirs at 72, open, with the hours you are both clear"
              className="w-full aspect-[4/5] sm:aspect-[16/10] object-cover object-center"
            />
          </motion.figure>
        </Reveal>

        <Reveal>
          <p
            className="mt-10 max-w-2xl mx-auto text-center text-base md:text-lg text-[#9DA1A8] leading-relaxed"
            data-testid="showcase-caption"
          >
            <span className="text-[#F2F0EB]">Read the room before you walk in.</span>{" "}
            Time the big conversation for when your codes agree.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
